import { useSnackbar } from 'notistack';

export const ToastVariants = {
  default: 'default',
  error: 'error',
  success: 'success',
  warning: 'warning',
  info: 'info',
};

export default function Toast() {
  const defaultMessage = 'Something went Wrong';
  const { enqueueSnackbar } = useSnackbar();
  const notify = (message, variant = 'success', duration = 2500) => {
    if (Array.isArray(message)) {
      for (const m of message) {
        enqueueSnackbar(m ?? defaultMessage, {
          variant,
          autoHideDuration: duration,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      }
    } else {
      enqueueSnackbar(message ?? defaultMessage, {
        variant,
        autoHideDuration: duration,
      });
    }
  };
  return notify;
}